import { i18n } from "@lingui/core";
import { messages as enMessages } from "./locales/en";
import { messages as heMessages } from "./locales/he";

export type AppLocale = "en" | "he";

const catalogs = {
	en: enMessages,
	he: heMessages,
};

export function activateLocale(locale: AppLocale) {
	const messages =
		locale === "en" ? enMessages : { ...enMessages, ...catalogs[locale] };
	i18n.loadAndActivate({
		locale,
		messages,
	});
}

activateLocale("en");

export { i18n };
